import { useContext } from 'react';
import { PanelStoreContext } from '../providers/PanelStoreProvider';
import type { PanelStore } from '../types/panelStore';

export const usePanelStore = (): PanelStore => {
  const store = useContext(PanelStoreContext);
  if (!store) {
    throw new Error('usePanelStore must be used within a PanelStoreProvider');
  }
  return store;
};
